import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserProfileService } from '../services';
import { Observable } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "../services/user-profile.service";
import * as i2 from "@angular/router";
var IsWebAdminGuard = /** @class */ (function () {
    function IsWebAdminGuard(profileService, router) {
        this.profileService = profileService;
        this.router = router;
    }
    IsWebAdminGuard.prototype.canActivate = function (next, state) {
        var _this = this;
        return Observable.create(function (observer) {
            _this.profileService.getUserProfile().subscribe(function (res) {
                if (res && res.webAdmin) {
                    observer.next(true);
                }
                else if (res && !res.webAdmin && state.url.startsWith('/report')) {
                    observer.next(true);
                }
                else {
                    _this.router.navigate(['/report/employee'], { replaceUrl: true });
                    observer.next(false);
                }
                observer.complete();
            });
        });
    };
    IsWebAdminGuard.ngInjectableDef = i0.defineInjectable({ factory: function IsWebAdminGuard_Factory() { return new IsWebAdminGuard(i0.inject(i1.UserProfileService), i0.inject(i2.Router)); }, token: IsWebAdminGuard, providedIn: "root" });
    return IsWebAdminGuard;
}());
export { IsWebAdminGuard };
